import { BASE_PATH as l, BaseAPI as V, operationServerMap as O } from "../base.js";
import { DUMMY_BASE_URL as h, assertParamExists as u, createRequestFunction as C, setSearchParams as v, toPathString as S } from "../common.js";
import G from "axios";
var P = function(t) {
  return {
    merchantStockConsumptionOrderGenerateConsumptionOrder: async (o, n, a = {}) => {
      u("merchantStockConsumptionOrderGenerateConsumptionOrder", "date", o), u("merchantStockConsumptionOrderGenerateConsumptionOrder", "shopId", n);
      const e = new URL("/merchant/wms/consumptionOrder/gen", h);
      let r;
      t && (r = t.baseOptions);
      const s = {
        method: "GET",
        ...r,
        ...a
      }, i = {}, c = {};
      o !== void 0 && (c.date = o instanceof Date ? o.toISOString().substring(0, 10) : o), n !== void 0 && (c.shopId = n), v(e, c);
      let m = r && r.headers ? r.headers : {};
      return s.headers = {
        ...i,
        ...m,
        ...a.headers
      }, {
        url: S(e),
        options: s
      };
    },
    merchantStockConsumptionOrderGetConsumptionOrder: async (o, n = {}) => {
      u("merchantStockConsumptionOrderGetConsumptionOrder", "query", o);
      const a = new URL("/merchant/wms/consumptionOrder/list", h);
      let e;
      t && (e = t.baseOptions);
      const r = {
        method: "GET",
        ...e,
        ...n
      }, s = {}, i = {};
      if (o !== void 0) for (const [m, d] of Object.entries(o)) i[m] = d;
      v(a, i);
      let c = e && e.headers ? e.headers : {};
      return r.headers = {
        ...s,
        ...c,
        ...n.headers
      }, {
        url: S(a),
        options: r
      };
    },
    merchantStockConsumptionOrderGetConsumptionOrderV2: async (o, n = {}) => {
      u("merchantStockConsumptionOrderGetConsumptionOrderV2", "command", o);
      const a = new URL("/merchant/wms/consumptionOrder/list_v2", h);
      let e;
      t && (e = t.baseOptions);
      const r = {
        method: "GET",
        ...e,
        ...n
      }, s = {}, i = {};
      if (o !== void 0) for (const [m, d] of Object.entries(o)) i[m] = d;
      v(a, i);
      let c = e && e.headers ? e.headers : {};
      return r.headers = {
        ...s,
        ...c,
        ...n.headers
      }, {
        url: S(a),
        options: r
      };
    },
    merchantStockConsumptionOrderGetProductConsumption: async (o, n = {}) => {
      u("merchantStockConsumptionOrderGetProductConsumption", "command", o);
      const a = new URL("/merchant/wms/consumptionOrder/product_consumption", h);
      let e;
      t && (e = t.baseOptions);
      const r = {
        method: "GET",
        ...e,
        ...n
      }, s = {}, i = {};
      if (o !== void 0) for (const [m, d] of Object.entries(o)) i[m] = d;
      v(a, i);
      let c = e && e.headers ? e.headers : {};
      return r.headers = {
        ...s,
        ...c,
        ...n.headers
      }, {
        url: S(a),
        options: r
      };
    }
  };
}, p = function(t) {
  const o = P(t);
  return {
    async merchantStockConsumptionOrderGenerateConsumptionOrder(n, a, e) {
      var r, s;
      const i = await o.merchantStockConsumptionOrderGenerateConsumptionOrder(n, a, e), c = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, m = (s = O["MerchantWmsConsumptionOrderApi.merchantStockConsumptionOrderGenerateConsumptionOrder"]) === null || s === void 0 || (s = s[c]) === null || s === void 0 ? void 0 : s.url;
      return (d, k) => C(i, G, l, t)(d, m || k);
    },
    async merchantStockConsumptionOrderGetConsumptionOrder(n, a) {
      var e, r;
      const s = await o.merchantStockConsumptionOrderGetConsumptionOrder(n, a), i = (e = t == null ? void 0 : t.serverIndex) !== null && e !== void 0 ? e : 0, c = (r = O["MerchantWmsConsumptionOrderApi.merchantStockConsumptionOrderGetConsumptionOrder"]) === null || r === void 0 || (r = r[i]) === null || r === void 0 ? void 0 : r.url;
      return (m, d) => C(s, G, l, t)(m, c || d);
    },
    async merchantStockConsumptionOrderGetConsumptionOrderV2(n, a) {
      var e, r;
      const s = await o.merchantStockConsumptionOrderGetConsumptionOrderV2(n, a), i = (e = t == null ? void 0 : t.serverIndex) !== null && e !== void 0 ? e : 0, c = (r = O["MerchantWmsConsumptionOrderApi.merchantStockConsumptionOrderGetConsumptionOrderV2"]) === null || r === void 0 || (r = r[i]) === null || r === void 0 ? void 0 : r.url;
      return (m, d) => C(s, G, l, t)(m, c || d);
    },
    async merchantStockConsumptionOrderGetProductConsumption(n, a) {
      var e, r;
      const s = await o.merchantStockConsumptionOrderGetProductConsumption(n, a), i = (e = t == null ? void 0 : t.serverIndex) !== null && e !== void 0 ? e : 0, c = (r = O["MerchantWmsConsumptionOrderApi.merchantStockConsumptionOrderGetProductConsumption"]) === null || r === void 0 || (r = r[i]) === null || r === void 0 ? void 0 : r.url;
      return (m, d) => C(s, G, l, t)(m, c || d);
    }
  };
}, b = function(t, o, n) {
  const a = p(t);
  return {
    merchantStockConsumptionOrderGenerateConsumptionOrder(e, r) {
      return a.merchantStockConsumptionOrderGenerateConsumptionOrder(e.date, e.shopId, r).then((s) => s(n, o));
    },
    merchantStockConsumptionOrderGetConsumptionOrder(e, r) {
      return a.merchantStockConsumptionOrderGetConsumptionOrder(e.query, r).then((s) => s(n, o));
    },
    merchantStockConsumptionOrderGetConsumptionOrderV2(e, r) {
      return a.merchantStockConsumptionOrderGetConsumptionOrderV2(e.command, r).then((s) => s(n, o));
    },
    merchantStockConsumptionOrderGetProductConsumption(e, r) {
      return a.merchantStockConsumptionOrderGetProductConsumption(e.command, r).then((s) => s(n, o));
    }
  };
}, y = class extends V {
  merchantStockConsumptionOrderGenerateConsumptionOrder(t, o) {
    return p(this.configuration).merchantStockConsumptionOrderGenerateConsumptionOrder(t.date, t.shopId, o).then((n) => n(this.axios, this.basePath));
  }
  merchantStockConsumptionOrderGetConsumptionOrder(t, o) {
    return p(this.configuration).merchantStockConsumptionOrderGetConsumptionOrder(t.query, o).then((n) => n(this.axios, this.basePath));
  }
  merchantStockConsumptionOrderGetConsumptionOrderV2(t, o) {
    return p(this.configuration).merchantStockConsumptionOrderGetConsumptionOrderV2(t.command, o).then((n) => n(this.axios, this.basePath));
  }
  merchantStockConsumptionOrderGetProductConsumption(t, o) {
    return p(this.configuration).merchantStockConsumptionOrderGetProductConsumption(t.command, o).then((n) => n(this.axios, this.basePath));
  }
};
export {
  y as MerchantWmsConsumptionOrderApi,
  P as MerchantWmsConsumptionOrderApiAxiosParamCreator,
  b as MerchantWmsConsumptionOrderApiFactory,
  p as MerchantWmsConsumptionOrderApiFp
};

//# sourceMappingURL=merchant-wms-consumption-order-api.js.map